import { render } from "./RightClickMenu.vue?vue&type=template&id=ba4b58b2&scoped=true"
import script from "./RightClickMenu.vue?vue&type=script&lang=js"
export * from "./RightClickMenu.vue?vue&type=script&lang=js"

import "./RightClickMenu.vue?vue&type=style&index=0&id=ba4b58b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4b58b2"]])

export default __exports__